export default "__VITE_ASSET__Cg965mEX__"